var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      ref: "addToWishList",
      staticClass: "btn btn-sm btn-link btn-lg text-dark",
      attrs: { "data-toggle": "tooltip", "data-placement": "top" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.switchState()
        }
      }
    },
    [
      _vm.isLoading
        ? _c(
            "svg",
            {
              staticClass: "icon icon-loader",
              attrs: { width: "32", height: "32", fill: "currentColor" }
            },
            [_c("use", { attrs: { "xlink:href": "#loader" } })]
          )
        : _vm.isVariationInWishList
        ? _c(
            "svg",
            {
              staticClass: "icon icon-heart-fill text-danger",
              attrs: { width: "32", height: "32", fill: "currentColor" }
            },
            [_c("use", { attrs: { "xlink:href": "#heart-fill" } })]
          )
        : _c(
            "svg",
            {
              staticClass: "icon icon-heart",
              attrs: { width: "32", height: "32", fill: "currentColor" }
            },
            [_c("use", { attrs: { "xlink:href": "#heart" } })]
          ),
      _vm._v(" Wunschliste\n")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }